var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#C4BBFD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.58214286,0 0,3.58214286 0,8 C0,12.4178571 3.58214286,16 8,16 C12.4178571,16 16,12.4178571 16,8 C16,3.58214286 12.4178571,0 8,0 Z M8.72142857,11.6678571 C8.70357143,12.3035714 8.23214286,12.6964286 7.62142857,12.6785714 C7.03571429,12.6607143 6.575,12.2428571 6.59285714,11.6035714 C6.61071429,10.9678571 7.09642857,10.5642857 7.68214286,10.5821429 C8.29642857,10.6 8.74285714,11.0321429 8.72142857,11.6678571 Z M10.4607143,7.12142857 C10.3107143,7.33214286 9.975,7.60357143 9.55357143,7.93214286 L9.08571429,8.25357143 C8.85714286,8.42857143 8.71428571,8.63571429 8.63928571,8.87142857 C8.6,8.99642857 8.57142857,9.32142857 8.56428571,9.53928571 C8.56071429,9.58214286 8.53571429,9.67857143 8.40357143,9.67857143 C8.27142857,9.67857143 7.15357143,9.67857143 7.00714286,9.67857143 C6.86071429,9.67857143 6.84285714,9.59285714 6.84642857,9.55 C6.86785714,8.95714286 6.95357143,8.46785714 7.2,8.075 C7.53214286,7.54642857 8.46785714,6.98928571 8.46785714,6.98928571 C8.61071429,6.88214286 8.72142857,6.76785714 8.80714286,6.64285714 C8.96428571,6.42857143 9.09285714,6.18928571 9.09285714,5.93214286 C9.09285714,5.63571429 9.02142857,5.35357143 8.83214286,5.11785714 C8.61071429,4.84285714 8.37142857,4.71071429 7.91071429,4.71071429 C7.45714286,4.71071429 7.19285714,4.93928571 7.00357143,5.23928571 C6.81428571,5.53928571 6.84642857,5.89285714 6.84642857,6.21428571 L5.10714286,6.21428571 C5.10714286,5 5.425,4.225 6.09642857,3.76785714 C6.55,3.45714286 7.12857143,3.32142857 7.80357143,3.32142857 C8.68928571,3.32142857 9.39285714,3.48571429 10.0142857,3.95714286 C10.5892857,4.39285714 10.8928571,5.00714286 10.8928571,5.83571429 C10.8928571,6.34642857 10.7142857,6.775 10.4607143,7.12142857 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.ef9c2565.svg";
export { ForwardRef as ReactComponent };